import type { SelectOptions } from 'mmfintech-backend-api/types'
import { isValidString } from 'mmfintech-commons'

export const extendedSelectOptions = (options: SelectOptions) =>
  Array.isArray(options)
    ? options.map(entry =>
        isValidString(entry.description)
          ? {
              value: entry.value,
              label: `${entry.label} (${entry.description})`
            }
          : entry
      )
    : options
